module.exports = __webpack_public_path__ + "static/media/Cold.2f8c5e5b.svg";